
import getCookie from '@src/quince-site-common/src/utils/getCookie'

import isBrowser from '../../../utils/isBrowser'
import { ZIP_COOKIE_KEY } from '../context/zipcode.context.provider'

export function validateZipCode(zipcode?: string) {
  if (!zipcode) {
    return false
  }
  if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode)) {
    return true
  }
  return false
}

export function getZipCodeFromCookie() {
  return getCookie(ZIP_COOKIE_KEY)
}

export function getZipCodeModalInitialState() {
  if (isBrowser()) {
    const hash = window.location.hash
    return hash === '#get-zip-code'
  }
  return false
}
